// App.js
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import "./App.css";
import TopBar from "./components/TopBar";
import "./customStyles/modals.css";
import { ROUTES } from "./utils/constants";
import { MediaProvider } from "./contexts/MediaContext";

function App() {
	const location = useLocation();
	const noTopBarScreens = [
		ROUTES.HOME,
		ROUTES.ENTER_CODE,
		ROUTES.REGISTER,
		ROUTES.PRESENTATION,
		ROUTES.ESCAPE_ROOM,
		ROUTES.START_GAME,
		ROUTES.START_GAME2,
		ROUTES.START_GAME3,
		ROUTES.START_GAME4,
		ROUTES.START_GAME5,
		ROUTES.SCENARIO1_INTRO,
		ROUTES.SCENARIO1_INSTRUCTIONS,
		ROUTES.CONGRATULATIONS,
		ROUTES.END,
		ROUTES.RESULTS,
		ROUTES.GAMEOVER,
		ROUTES.WARMUP,
		ROUTES.FINAL_SCENE
	];
	const showTopBar = !noTopBarScreens.some(
		(x) => location.pathname.toString() === x
	);

	window.onbeforeunload = function () {
		return "Your work will be lost.";
	};

	return (
		<MediaProvider>
			<div className={`App ${showTopBar ? "" : ""}`}>
				{showTopBar && (
					<div>
						<TopBar />
					</div>
				)}
				<Outlet />
			</div>
		</MediaProvider>
	);
}
export default App;
